/**
 * bz-anti-fatigue-mentale.js — FR marché
 * Guide Anti-Fatigue Mentale — JavaScript de la page
 * Hérite de la logique de adhd-supplements-guide.js.
 * Config spécifique : PRO recommandé, code BIENVENUE10, messages symptômes FR.
 * Créé : 2026-04-27 — Session 32 wave 2 overnight
 * ANSM : utilise "soutenir" et non "augmenter/booster" tout au long.
 * Produit principal : surmenage-fatigue-mentale → PRO lane motivation/dopamine.
 */

/* ─────────────────────────────────────────────────────────────────────
   1. CONFIG PARTAGÉE
   ───────────────────────────────────────────────────────────────────── */

window.BZ = window.BZ || {};

BZ.PRODUCTS = BZ.PRODUCTS || {
  fr: {
    elite: {
      name: 'FOCUS ELITE™',
      shortName: 'ELITE',
      price: '€52',
      priceSub: '€43,68/mois',
      url: 'https://www.brainzyme.fr/products/brainzyme-focus-elite-surmenage-fatigue-mentale',
      cart: 'https://brainzyme-fr.myshopify.com/cart/39813724831849:1',
      purpose: 'Concentration sans stress, humeur positive &amp; santé cérébrale'
    },
    pro: {
      name: 'FOCUS PRO™',
      shortName: 'PRO',
      price: '€31.75',
      priceSub: '€26,67/mois',
      url: 'https://www.brainzyme.fr/products/brainzyme-professionnel-formule-renforcee-concentration-et-motivation-un-complement-nutritionnel-d-optimisation-de-performance-cognitive-nootropique-naturel',
      cart: 'https://brainzyme-fr.myshopify.com/cart/28966088867945:1',
      purpose: 'Concentration intense, motivation &amp; mémoire'
    },
    original: {
      name: 'FOCUS ORIGINAL™',
      shortName: 'ORIGINAL',
      price: '€19.80',
      priceSub: '€16,63/mois',
      url: 'https://www.brainzyme.fr/products/brainzyme-original-formule-douce-concentration-et-motivation-un-complement-nutritionnel-d-optimisation-de-performance-cognitive-nootropique-naturel',
      cart: 'https://brainzyme-fr.myshopify.com/cart/28966039584873:1',
      purpose: 'Concentration douce et quotidienne, humeur calme'
    },
    bundle: {
      name: 'Starter Bundle',
      shortName: 'Bundle',
      price: '€47.80',
      priceSub: '€40,15/mois',
      url: 'https://www.brainzyme.fr/products/nouveau-brainzyme-pack-combo-x1-elite-x1-professionnel-x1-original-un-complement-nutritionnel-d-optimisation-de-performance-cognitive-nootropique-naturel',
      cart: 'https://www.brainzyme.fr/products/nouveau-brainzyme-pack-combo-x1-elite-x1-professionnel-x1-original-un-complement-nutritionnel-d-optimisation-de-performance-cognitive-nootropique-naturel',
      purpose: 'Les 3 formules &mdash; essayez-les toutes'
    }
  }
};

/* ─────────────────────────────────────────────────────────────────────
   2. LP_CONFIG — voie Fatigue Mentale (PRO principal)
   ───────────────────────────────────────────────────────────────────── */

var LP_CONFIG = {
  product: 'pro',
  market: 'fr',
  discountCode: 'BIENVENUE10',
  recommendedSku: 'pro'
};

/* ─────────────────────────────────────────────────────────────────────
   3. RAYONNAGE PRODUITS — PRO en premier (badge recommandé sur PRO)
   ───────────────────────────────────────────────────────────────────── */

(function () {
  var market = 'fr';
  var p = BZ.PRODUCTS[market];

  var PRODUCTS = [
    {
      key: 'pro',
      name: p.pro.name,
      pill: 'Recommandé pour la fatigue mentale',
      price: p.pro.price,
      priceSub: p.pro.priceSub,
      purpose: p.pro.purpose,
      url: p.pro.url,
      cart: p.pro.cart,
      features: [
        'Voie dopamine + acétylcholine complète',
        '20 ingrédients dérivés de plantes',
        'L-Tyrosine, B6, B12, Ginkgo Biloba',
        'Concentration soutenue pendant 6–8 h',
        'Non habituogène, à base de plantes'
      ]
    },
    {
      key: 'elite',
      name: p.elite.name,
      pill: null,
      price: p.elite.price,
      priceSub: p.elite.priceSub,
      purpose: p.elite.purpose,
      url: p.elite.url,
      cart: p.elite.cart,
      features: [
        'Formule stress + concentration',
        '29 ingrédients, voie GABA',
        'Concentration sans stress',
        'Pour les journaux chargés avec pression',
        'Non habituogène, à base de plantes'
      ]
    },
    {
      key: 'original',
      name: p.original.name,
      pill: null,
      price: p.original.price,
      priceSub: p.original.priceSub,
      purpose: p.original.purpose,
      url: p.original.url,
      cart: p.original.cart,
      features: [
        'Formule douce pour débuter',
        '12 ingrédients, soutien de base',
        'Concentration légère et quotidienne',
        'Idéal pour une introduction progressive',
        'Non habituogène, à base de plantes'
      ]
    }
  ];

  var shelf = document.getElementById('productShelf');
  if (!shelf) return;

  shelf.innerHTML = PRODUCTS.map(function (prod) {
    return '<div class="product-card' + (prod.pill ? ' product-card--featured' : '') + '">'
      + (prod.pill ? '<div class="product-pill">' + prod.pill + '</div>' : '')
      + '<div class="product-name">' + prod.name + '</div>'
      + '<div class="product-purpose">' + prod.purpose + '</div>'
      + '<ul class="product-features">'
      + prod.features.map(function (f) { return '<li>' + f + '</li>'; }).join('')
      + '</ul>'
      + '<div class="product-price">' + prod.price + '</div>'
      + '<div class="product-price-sub">' + prod.priceSub + '</div>'
      + '<a class="product-cta" href="' + prod.cart + '">Essayer ' + prod.shortName + '</a>'
      + '<a class="product-learn" href="' + prod.url + '">En savoir plus</a>'
      + '</div>';
  }).join('');
})();

/* ─────────────────────────────────────────────────────────────────────
   4. STICKY CTA
   ───────────────────────────────────────────────────────────────────── */

(function () {
  var sticky = document.getElementById('stickyCta');
  if (!sticky) return;
  var p = BZ.PRODUCTS.fr.pro;
  sticky.innerHTML = '<div class="sticky-cta">'
    + '<span class="sticky-label">Retrouvez votre concentration &mdash; FOCUS PRO™</span>'
    + '<a href="' + p.cart + '" class="sticky-btn">Essayer maintenant &mdash; ' + p.price + '</a>'
    + '</div>';
})();

/* ─────────────────────────────────────────────────────────────────────
   5. SÉLECTEUR DE SIGNES DE FATIGUE (interactif)
   ───────────────────────────────────────────────────────────────────── */

(function () {
  var RESULTS = [
    null,
    'Vous avez identifié 1 signe. Peut-être une journée difficile, ou les débuts d’une fatigue mentale qui mérite attention.',
    'Vous avez identifié 2 signes. Des schémas se forment. Une routine de soutien pourrait aider.',
    'Vous avez identifié 3 signes. Votre cerveau énergétique a besoin d’un soutien actif. Commencez par les bases du mode de vie ci-dessous.',
    'Vous avez identifié 4 signes. La fatigue mentale affecte votre productivité. Un soutien nutritionnel ciblé en plus du mode de vie peut aider.',
    'Vous avez identifié 5 signes. Fatigue mentale significative. Consultez un médecin si les symptômes persistent et considérez un soutien nutritionnel ciblé.',
    'Vous avez identifié les 6 signes. Parlez-en à votre médecin. En attendant, les stratégies de mode de vie et le soutien nutritionnel ci-dessous sont un bon point de départ.'
  ];

  var count = 0;
  var signs = document.querySelectorAll('.sign-item.selectable');
  var countEl = document.getElementById('symptomCount');
  var resultEl = document.getElementById('symptomResult');
  var fillEl = document.querySelector('.fatigue-score-fill');
  var fillLabelEl = document.querySelector('.fatigue-score-label');

  signs.forEach(function (el) {
    el.addEventListener('click', function () {
      var checked = el.getAttribute('aria-checked') === 'true';
      el.setAttribute('aria-checked', checked ? 'false' : 'true');
      el.classList.toggle('selected', !checked);
      count = document.querySelectorAll('.sign-item.selected').length;
      if (countEl) countEl.textContent = count;
      if (resultEl) resultEl.textContent = count > 0 ? RESULTS[count] : '';
      if (fillEl) fillEl.style.width = Math.round((count / 6) * 100) + '%';
      if (fillLabelEl) fillLabelEl.textContent = count + '/6';
    });
    el.addEventListener('keydown', function (e) {
      if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); el.click(); }
    });
  });
})();

/* ─────────────────────────────────────────────────────────────────────
   6. ACCORDÉON PREUVES
   ───────────────────────────────────────────────────────────────────── */

function toggleAccordion(btn) {
  var expanded = btn.getAttribute('aria-expanded') === 'true';
  btn.setAttribute('aria-expanded', String(!expanded));
  var panel = btn.nextElementSibling;
  if (panel) panel.style.display = expanded ? 'none' : 'block';
  var chevron = btn.querySelector('.accordion-chevron');
  if (chevron) chevron.textContent = expanded ? '+' : '−';
}

/* ─────────────────────────────────────────────────────────────────────
   7. GUIDE D'ACHAT — progression des critères
   ───────────────────────────────────────────────────────────────────── */

(function () {
  var checks = document.querySelectorAll('.guide-checklist li[data-check]');
  var progressDots = document.querySelectorAll('.check-dot[data-check]');
  var labelEl = document.getElementById('checkLabel');
  var seen = new Set();

  function updateProgress() {
    var total = progressDots.length;
    progressDots.forEach(function (dot) {
      dot.classList.toggle('done', seen.has(dot.getAttribute('data-check')));
    });
    if (labelEl) labelEl.textContent = seen.size + '/' + total + ' explorés';
  }

  checks.forEach(function (li) {
    li.addEventListener('click', function () {
      var key = li.getAttribute('data-check');
      if (!seen.has(key)) { seen.add(key); }
      updateProgress();
    });
  });
})();

/* ─────────────────────────────────────────────────────────────────────
   8. CARROUSEL — init via bz-component-carousel snippet
   ───────────────────────────────────────────────────────────────────── */

/* The bz-component-carousel snippet handles Embla init.
   No standalone init needed here — snippet fires on DOMContentLoaded. */

/* ─────────────────────────────────────────────────────────────────────
   9. BARRE DE PROGRESSION (scroll)
   ───────────────────────────────────────────────────────────────────── */

(function () {
  var bar = document.getElementById('progressBar');
  var label = document.getElementById('progressLabel');
  if (!bar) return;
  function onScroll() {
    var scrollTop = window.scrollY || document.documentElement.scrollTop;
    var docHeight = document.documentElement.scrollHeight - window.innerHeight;
    var pct = docHeight > 0 ? Math.round((scrollTop / docHeight) * 100) : 0;
    bar.style.width = pct + '%';
    if (label) label.textContent = pct + '%';
  }
  window.addEventListener('scroll', onScroll, { passive: true });
})();

/* ─────────────────────────────────────────────────────────────────────
   10. ANIMATIONS COMPTEURS (stats)
   ───────────────────────────────────────────────────────────────────── */

(function () {
  var DURATION = 1200;
  function animateCount(el) {
    var target = parseInt(el.getAttribute('data-target'), 10);
    if (isNaN(target)) return;
    var suffix = el.innerHTML.replace(String(target), '').replace('0', '');
    var start = performance.now();
    function step(now) {
      var t = Math.min((now - start) / DURATION, 1);
      var cur = Math.round(t * target);
      el.innerHTML = cur + suffix;
      if (t < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        animateCount(entry.target);
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.5 });

  document.querySelectorAll('[data-target]').forEach(function (el) { io.observe(el); });
})();
